<script setup lang="ts">
const dropdownItems = [
  [
    {
      label: 'Documentation',
      to: 'https://help.sleuth.io',
      target: '_blank',
      icon: 'regular:book',
    },
    {
      label: 'Leave feedback',
      to: 'mailto:support@sleuth.io?subject=Pulse%20Feedback',
      icon: 'regular:message-smile',
    },
  ],
]
</script>

<template>
  <UDropdown :items="dropdownItems" :ui="{ width: 'w-56' }">
    <NavigationItem icon="regular:circle-question" label="Help" />
  </UDropdown>
</template>
